var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"pt-5",attrs:{"align":"center","justify":"center"}},[_c('v-card',{staticClass:"mb-5",attrs:{"elevation":"0","width":"1228"}},[_c('ServiceHiring',{attrs:{"service-type":_vm.serviceType,"service-id":_vm.serviceId,"professional-id":_vm.professionalId,"is-pay":_vm.isPay}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }